import { Card } from "antd";
import "./index.scss";
import { Container } from "../../../components";
import { getImageUrl } from "../../../utils/image";
import React from "react";
export var WhyApiKey = function WhyApiKey() {
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Card, {
    title: /*#__PURE__*/React.createElement("img", {
      className: "header-logo",
      src: getImageUrl("tatum-logo.svg")
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "whyApiKey"
  }, "Why do I need an API key to sell NFTs?"), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, "Normally, to create NFTs on different blockchains, you would need to have access to blockchain nodes and create wallets on each blockchain. With NFT Maker, you can simply use an API key to connect to different blockchains through Tatum, and everything else is taken care of for you.")));
};